export enum EFileStatus {
  Uploading = 'uploading',
  Done = 'done',
  Error = 'error',
}
